import { LockManager, sleep } from '@pulse/common';

export class QueueService {
    constructor(private lockManager: LockManager) {}

    async waitQueueOpen(
        hash: string,
        timeout: number,
        locks: string[] = [],
    ): Promise<string | null> {
        let tries = 0;
        do {
            if (await this.lockManager.locked(hash)) {
                await sleep(50);
                tries += 50;
                continue;
            } else if (locks.includes(hash)) {
                await sleep(50);
                tries += 50;
                continue;
            } else {
                return hash;
            }
        } while (tries < timeout);
        console.error('Request Timed Out For Setting');

        return null;
    }
}
